import React from 'react';
import {classes, style} from './doppe-layout-bio-text.st.css';
import {DoppeHideableValue, doppeHideableValueGetVisibleValue} from '../../../../client-server-common';
import {evaluateFunction, stringIsNotNullableOrWhiteSpace} from '@wix/devzai-utils-common';
import {ExpandableText, MultilineExpandableText} from '@wix/devzai-utils-react';
import {useDoppeViewerLocales} from '../../../../client/doppe-viewer-locales/doppe-viewer-locales';
import {CommonClasses} from '@wix/devzai-common-client';

export const DoppeLayoutBioText = React.memo(function DoppePagesSearchAction(props: DoppePagesSearchAction.Props) {
    const {
        className,
        children,

        lineClamp,
        bioText,
        bioTextMaxLines,
        lineHeight,

        ...htmlAttributes
    } = props;

    const doppeViewerLocales = useDoppeViewerLocales();
    const bioTextVisibleValue = doppeHideableValueGetVisibleValue(bioText, '');


    return (
        <>
            {stringIsNotNullableOrWhiteSpace(bioTextVisibleValue) ? evaluateFunction(() => {

                const maxVisibleLines =
                    doppeHideableValueGetVisibleValue(bioTextMaxLines, Infinity);

                if (maxVisibleLines === Infinity) {
                    return (
                        <div
                            {...htmlAttributes}
                            className={style(classes.root, {}, className, lineClamp ? CommonClasses.lineClamp(lineClamp) : undefined)}
                        >
                            {bioTextVisibleValue}
                        </div>
                    )
                } else if (maxVisibleLines > 1) {
                    return (
                        <MultilineExpandableText
                            {...htmlAttributes}
                            className={style(classes.multilineRoot, {}, className, classes.root)}
                            text={bioTextVisibleValue}
                            expandButtonText={doppeViewerLocales['seeMore']}
                            lineHeight={lineHeight}
                            maxLines={maxVisibleLines}
                            collapseOnTextChange={true}
                        />
                    )
                } else {
                    return (
                        <ExpandableText
                            {...htmlAttributes}
                            className={style(classes.root, {}, className)}
                            seeMoreButtonContent={(
                                <div
                                    className={style(classes.seeMoreButton, {})}>{doppeViewerLocales['seeMore']}</div>
                            )}
                        >
                            {bioTextVisibleValue}
                        </ExpandableText>
                    )
                }
            }) : null}
        </>
    )
});

export namespace DoppePagesSearchAction {

    export interface Props extends React.HTMLAttributes<any> {
        bioText: DoppeHideableValue<string>;
        bioTextMaxLines: DoppeHideableValue<number>;
        lineHeight: string;
        lineClamp?: 2 | 3 | 4 | 8;
    }
}